import type { VoidFunctionComponent } from 'react';

import { plural } from '../../../../../shared/helpers/plural';
import Card from '../../../generic/Card/Card';
import DocsLink from '../../../generic/Link/DocsLink';

import styles from './GeneralSettings.module.less';

type Props = {
  count: number;
};

/**
 * ContributorCount displays the number of contributors to a project.
 */
const ContributorCount: VoidFunctionComponent<Props> = ({ count }) => (
  <Card isFullWidth>
    <Card.Header>
      {count.toLocaleString()} {plural(count, 'Contributor')}
    </Card.Header>
    <Card.Content>
      <p className={styles.contributorCountPanelText}>
        Read more about how FOSSA counts contributors
        {' '}
        <DocsLink
          to="counting-contributors"
          openInNewTab
        >
          here
        </DocsLink>.
      </p>
    </Card.Content>
  </Card>
);

export default ContributorCount;
